import {createSlice} from "@reduxjs/toolkit"
export const loginDetails = createSlice({
    name : "Resend OTP",
    initialState :{
        loginEmail:"",
        loginPassword:""
      },
    reducers:{
        setLoginEmail: (state, action) => {
            return {
              ...state,
              loginEmail: action.payload,
            };
          },
          setLoginPassword: (state, action) => {
            return {
              ...state,
              loginPassword: action.payload,
            };
          }
       }
})
export const {setLoginEmail, setLoginPassword} = loginDetails.actions;